import React from 'react';
import {Mutation} from 'react-apollo'

import Notifications from './Notifications'

import query from '../../../queries/server/notifications'
import mutation from '../../../queries/server/mutations/update_user_viewed_notifications'

const NotificationsContainer = (props) => {
  return (
    <Mutation 
      mutation={mutation}
      update={(cache, {data: {updateViewedNotificationsAt}}) => {
        const {me, notifications} = cache.readQuery({query, variables: {office_id: props.user.office_id}})
        cache.writeQuery({
          query,
          data: {me: {...me, ...updateViewedNotificationsAt}, notifications}
        })
      }}
    >
      {(updateFunc) => (
        <Notifications {...props} setTimeOnUnmount={updateFunc}/>
      )}
    </Mutation>
  )
}

export default NotificationsContainer